import axios from "axios";
import { handleAPIError, handleAPISuccess } from "./utils/utilsAPI";
import {createImageValidation, tokenAndIdValidation } from "./utils/validateAPI";
import { BASE_URL } from "./constant";

const token = "8lQzN922rpRDaMbh3m5J";

const apiImage = axios.create({
  baseURL: `${BASE_URL}/images`,
});

/**
 * validates the argument received and Makes an API call to create or update the Image
 * @param {object} imageDetail - contains all the data required to create a image
 * @returns {Promise} - Resolves when the promise returns image details  or logs in case of failure.
 */
const createImage = async (imageDetail) => {
  const payload = {token:token,...imageDetail}
  try {
    await createImageValidation.validate(payload);
    const res = await apiImage.post(`/`, payload);
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);  
    handleAPIError(err);  // Call error handler
    throw err;  
  }
};

/**
 * validates the argument received and Makes an API call to get the image
 * @param {string} id - id of the charger to get the particular image details or "all" to get all the image
 * @returns {Promise} - Resolves when the promise returns all the chargers or empty array in case of no charger or logs in case of failure.
 */
const getImage = async (id) => {
  const payload = {
    token: token,
    id: id,
  };
  try {
    await tokenAndIdValidation.validate(payload);
    const res = await apiImage.get(`/`, { params: payload });
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);  
    handleAPIError(err);  // Call error handler
    throw err;  
  }
};

/**
 * validates the argument received and Makes an API call to delete the image
 * @param {string} id - id of the charger to delete the image
 * @returns {Promise} - Resolves when the promise returns id of the image or logs in case of failure.
 */
const deleteImage = async (id) => {
  const payload = {
    token: token,
    id: id,
  };
  try {
    await tokenAndIdValidation.validate(payload);
    const res = await apiImage.delete(`/`, { data: payload });
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);  
    handleAPIError(err);  // Call error handler
    throw err;  
  }
};

export { createImage, getImage, deleteImage };
